import { Container, ErrorBoundary, Head } from "@/components"
import { usePdp, usePdpGtm, usePdpStructuredData } from "@jog/react-components"
import { PropsWithChildren } from "react"

export const Main = ({ children }: PropsWithChildren) => {
    const {
        detail: { name, description, paths, desktopImages },
        pdp: { metaTagRobots },
    } = usePdp()
    const productStructuredDataJSON = usePdpStructuredData()
    usePdpGtm()
    return (
        <ErrorBoundary system="PDP">
            <Head
                og={{ title: name, description, image: desktopImages[0]?.url }}
                alternate={paths}
                title={`${name} | GARCIA`}
                description={description}
                robots={metaTagRobots}>
                {productStructuredDataJSON && <script type="application/ld+json">{productStructuredDataJSON}</script>}
            </Head>
            <Container>{children}</Container>
        </ErrorBoundary>
    )
}
